/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsBaseForSaasAiServices extends models.ServiceAccountNativeDetailsForSaas {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsBaseForSaasAiServices");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsBaseForSaasAiServices.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsBaseForSaasAiServices>): ServiceAccountNativeDetailsBaseForSaasAiServices {
        let obj = Object.assign(new ServiceAccountNativeDetailsBaseForSaasAiServices(), model);
        ServiceAccountNativeDetailsBaseForSaasAiServices.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsBaseForSaasAiServices>): ServiceAccountNativeDetailsBaseForSaasAiServices {
        if (!model) return null;
        return ServiceAccountNativeDetailsBaseForSaasAiServices.newInstance(<ServiceAccountNativeDetailsBaseForSaasAiServices> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsBaseForSaasAiServices) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsBaseForSaasAiServices.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsBaseForSaasAiServices): boolean {
        if (models.ServiceAccountNativeDetailsForSaas.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsBaseForSaasAiServices.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
